import cn from '@/lib/cs';
import React from 'react';

const StopIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M20 4c0-.7-.3-1-.6-1-1 0-1.9.4-2.8.4-3.7 0-8.4.6-12-.2-.4-.1-.9 0-1.1.4a1 1 0 0 0-.3.6c-.3 4.7 0 10.5-.1 13.3 0 .9 0 1.8.2 2.6l.2.8h.1c8.8-1.5 9.9-.2 16-.1h.3c.3.1.6 0 .8-.2l.1-.2.2-.6V19c-.4-5 0-10.2-1-15Z"
		/>
	</svg>
);

export default StopIcon;
